import clsx from "clsx";
import { formatPercentage } from "@/utils/format";
import styles from "./styles.module.scss";

interface DonutProps {
  economyClass: string;
  percent?: number;
  description: React.ReactNode;
  srDescription: string;
}

const donutSize = 100;
const strokeWidth = 20;
const radius = 30;
const startAngle = -90;

export function Donut({
  economyClass,
  percent,
  description,
  srDescription,
}: DonutProps) {
  const displayPercentage =
    percent || percent === 0 ? formatPercentage(percent) : "";
  const circumference = radius * 2 * Math.PI;

  // Ensure all <1% values have the same visual display
  const strokePercent = displayPercentage == "<1%" ? 0.005 : percent;

  return (
    <div>
      <span className={styles.hide}>{srDescription}</span>
      <div
        className={clsx(
          styles["chart-wrap"],
          styles[economyClass],
          description === "No data" && [styles["no-data"]]
        )}
        aria-hidden
      >
        <svg className={styles.svg} viewBox={`0 0 ${donutSize} ${donutSize}`}>
          <circle
            className={styles["donut-background"]}
            fill="transparent"
            strokeWidth={strokeWidth}
            r={radius}
            cx={donutSize / 2}
            cy={donutSize / 2}
          />
          <circle
            strokeDasharray={`${
              (circumference * Math.round((strokePercent || 0) * 100)) / 100
            } ${circumference}`}
            strokeDashoffset="0"
            transform={`rotate(${startAngle} ${donutSize / 2} ${
              donutSize / 2
            })`}
            className={styles["donut-ring"]}
            fill="transparent"
            strokeWidth={strokeWidth}
            r={radius}
            cx={donutSize / 2}
            cy={donutSize / 2}
          />
        </svg>

        <div className={styles.caption}>
          <h4 className={styles.percent}>{displayPercentage}</h4>
          <p className={styles.description}>{description}</p>
        </div>
      </div>
    </div>
  );
}
